import React from 'react'
import { convertIntoLakh } from '../UtilityComponents/UtilityFunction'
import { useEffect } from 'react'
import { useState } from 'react';

const BarGraph = ({ year, percent, amt }) => {
    const [height, setheight] = useState(0);

    

    useEffect(() => {
        setheight(0);

        let timer = setTimeout(() => {
            setheight(percent);
        }, 300);

        return () => clearTimeout(timer);
    }, [percent, amt]);

return (
        <div className="CalcGraph">
            <span>₹{convertIntoLakh(amt)}</span>
        <div className="GraphBar">
            <div style={{ width: `${height * 2}px` }} className='bar'></div>
            </div>
            <span className="InYear">in {year} yrs</span>
        </div>
    )
}

export default BarGraph
